import React from 'react';
import ValuePropCard from './ValuePropCard';
import getLocaleMessages from '../../../utils/localesMessages';

const { valueProp } = getLocaleMessages('buttonsV3/login');

const images = [
  '/paypal-ui/illustrations/focused/svg/donation-page-hourglass.svg',
  '/paypal-ui/illustrations/focused/svg/hand-image.svg',
  '/paypal-ui/illustrations/focused/svg/money-down.svg',
];

const ValueProp = () => {
  const getValuePropContent = () => {
    return Object.keys(valueProp).map((key) => valueProp[key]);
  };
  return (
    <div className="value-prop-msgs-container">
      <div className="value-prop-msgs">
        {getValuePropContent().map((col, index) => (
          <ValuePropCard
            heading={col.heading}
            body={col.body}
            imgSrc={images[index]}
            key={index}
          />
        ))}
      </div>
    </div>
  );
};

export default ValueProp;
